import { Box } from '@mui/material';
import { AnalyticsColors } from './analyticsUi';

interface ClickableNameProps {
    onClick: () => void;
    children: React.ReactNode;
}

const ClickableName = ({ onClick, children }: ClickableNameProps) => (
    <Box
        component="span"
        onClick={onClick}
        sx={{
            color: AnalyticsColors.primary,
            cursor: 'pointer',
            fontWeight: 600,
            transition: 'color 0.15s',
            '&:hover': {
                textDecoration: 'underline',
            },
        }}
    >
        {children}
    </Box>
);

export default ClickableName;
